import React from 'react';
import { AutocompleteSelect } from '@this/shared/ui/inputs/autocomplete';

export interface ShareholderTicketFeeOrganizationOption {
  id: number;
  name: string;
}

const ALL_ORGANIZATION_OPTION: ShareholderTicketFeeOrganizationOption = { id: 0, name: '全体' };

interface Props {
  options: ShareholderTicketFeeOrganizationOption[];
  value: string;
  onSelect: (org: ShareholderTicketFeeOrganizationOption | null) => void;
}

export const ShareholderTicketFeesOrganizationSelect: React.FC<Props> = ({ options, value, onSelect }) => {
  if (options.length === 0) {
    return null;
  }

  const autocompleteOptions = [ALL_ORGANIZATION_OPTION, ...options];
  const selectedOrganizationId = value || String(ALL_ORGANIZATION_OPTION.id);
  const selectedOrganization = autocompleteOptions.find(org => String(org.id) === selectedOrganizationId) || null;

  return (
    <AutocompleteSelect
      options={autocompleteOptions}
      value={selectedOrganization}
      placeholder="法人を選択"
      getOptionLabel={org => org.name}
      onChange={(_, selected) => {
        onSelect(selected);
      }}
    />
  );
};
